import React, { useContext, useEffect, useState } from "react";
import "./Cart_Product_Card.css";
import { IDS } from "../../../utils/IDS";
import { getAllCart, postCartQuantity } from "../../../features/cart/cartSlice";
import { Context } from "../../../utils/context";
import { useDispatch } from "react-redux";

const Cart_Product_Card = ({ cartItem }) => {

  const [count, setCount] = useState(1)

  const [newcart, setNewCart] = useState();
  const { signin } = useContext(Context);
  const dispatch = useDispatch();


  const cartQuantity = async (type) => {
    try {

      const data = {
        cart_id: cartItem?.id,
        type: type,
        isSignIn: signin,
        product_id: cartItem.product_id,
        variant_id: cartItem.variant_id,
      };
      const res = await dispatch(postCartQuantity(data));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(signin));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    if (cartItem?.length > 0) {
      for (const item of cartItem) {
        if (item?.product_id === newcart?.product_id) {
          setNewCart(item);
        }
      }
    }
  }, [cartItem]);

  return (
    <section className="Cart_Product_Card">
      <div className="row">

        <div className="col-sm-3">
          <div className="left_side_img">
            <img
              src={IDS.IMG_URL + cartItem?.Product?.image}
              className="prod_img"
            />
          </div>
        </div>
        <div className="col-sm-9">
          <div className="right_side">
            <div className="info_div">
              <p className="prod_name">{cartItem?.Product?.name || " "}</p>
              <p className="price_text">
                ₹ {
                  cartItem?.Product
                    ? (
                      (cartItem.Product.price * cartItem.quantity)
                      // +
                      // ((cartItem.Product.price * cartItem.quantity) * (parseFloat(cartItem.Product.tax_percentage) / 100))
                    ).toFixed(2)
                    : "0"
                }
              </p>
            </div>

            <div className="inc_dec_div">
              <div className="count_div">
                <p className="count_text">{cartItem?.quantity}</p>
              </div>
              <div className="action_btns">
                <div className="btn_div" onClick={() => {
                  cartQuantity("add");
                }}>
                  <span className="sign">+</span>
                </div>
                <div className="btn_div" onClick={() => {
                  cartQuantity("minus");
                }}>
                  <span className="sign">-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cart_Product_Card;
